import { render, staticRenderFns } from "./TripartiteDefinitionForm.vue?vue&type=template&id=416b6f83&scoped=true"
import script from "./TripartiteDefinitionForm.vue?vue&type=script&lang=js"
export * from "./TripartiteDefinitionForm.vue?vue&type=script&lang=js"
import style0 from "./TripartiteDefinitionForm.vue?vue&type=style&index=0&id=416b6f83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b6f83",
  null
  
)

export default component.exports